import { Controller } from "@hotwired/stimulus"
import SlimSelect from "slim-select"

export default class extends Controller {
  static values = {
    options: Object
  }
  
  connect() {
    const defaultOptions = {
      settings: {
        placeholderText: 'Selecione opções',
        allowDeselect: true,
        closeOnSelect: false
      }
    }
    
    const options = {
      ...defaultOptions,
      ...this.optionsValue,
      select: this.element
    }
    
    this.slimSelect = new SlimSelect(options)
  }
  
  disconnect() {
    if (this.slimSelect) {
      this.slimSelect.destroy()
    }
  }
}